import { FORM_TYPES, LEGALES_LEALTAD_AFS, LEGALS } from "../../data/AudiNuevo/preventa";

const LegalesComponent = ({ formType, modelPathName, utms }) => {
  let legalText = '';
  if (formType !== FORM_TYPES.PREVENTA.LEALTAD && formType !== FORM_TYPES.PREVENTA.CONQUISTA) {
    return null
  }

  if (formType === FORM_TYPES.PREVENTA.LEALTAD) {
    legalText = LEGALS[modelPathName]?.LEALTAD || "";
  } else if (formType === FORM_TYPES.PREVENTA.CONQUISTA) {
    legalText = LEGALS[modelPathName]?.CONQUISTA || "";
  }

  if (utms.utm_id && utms.utm_id === "PreventaAFS") {
    legalText = LEGALES_LEALTAD_AFS[modelPathName].LEGAL || "";
  }
  return (
    <div className="mt-5 pt-5">
      <p className="mb-5" style={{ fontSize: '0.9rem' }}>
        {legalText}
      </p>
    </div>
  )
}

export default LegalesComponent;